import Styled from 'styled-components'

export const Container = Styled.div`
 margin: 5%;
`
export const Banner = Styled.div`

.carousel-control-prev-icon{
    background-image: none !important;
}

.carousel-control-next-icon{
    background-image: none !important;
}


.carousel {
    display: flex;
    flex-direction: column;
}

.carousel-inner {
    order: 1;
}

.carousel-indicators {
    position: static !important;
    order: 2;
    margin-top: 18px;
    margin-bottom: 0;
}

button{
width: 8px !important;
height: 8px !important; 
background-color: var(--primary-color) !important;
border-radius: 100% !important;
}

`
export const ContainerTicketData = Styled.section`
margin-top: 25px;
`


export const SearchTicket = Styled.h3`
font-size: 20px;
color: var(--text-color);
font-weight: 600;
margin-bottom: 32px;
`

export const CheckboxContainer = Styled.div`
margin-top: 8px;
display: flex;
gap: 32px;


label{
padding-left: 8px;
cursor: pointer;
color: var(--text-color);
font-family: var(--font-family-base);
font-weight: 400;
font-size: 14px;
line-height: 100%;
@media(max-width: 800px) {
  font-size: 14px;
}
&:active{
    color: #9DA1A6;
}
}

@media(max-width: 800px) {
    line-height: 20px;
}
`

export const ContainerContent = Styled.form`
margin: 0 auto;
width: 100%;
height: auto;
padding: 16px;
background-color: white;
position: relative;

@media(max-width: 800px) {
width: 96%;
height: auto;
}
`

export const Label = Styled.h4`
font-size: 20px;
font-weight: bold;
margin-top: 25px;
margin-bottom: 20px;
`
export const Ticket = Styled.h4`
font-size: 20px;
font-weight: bold;
margin-top: 50px;
margin-bottom: 40px;
`
export const Spance = Styled.div`
height: 10px;

`
export const ContainerCarousel = Styled.div`
  .swiper-pagination-bullet{
    display: none !important;
  }
`

export const Img = Styled.img`
 cursor: pointer;
 display: block;
 width: 100%;
 height: 100%;
object-fit: cover;
`
export const Cidade = Styled.p`
background-color: var(--secondary-color);
text-align: center;
font-weight: 700;
font-size: 12px;
color: white;
padding-top: 5px;
padding-bottom: 5px;
border-bottom-left-radius: 5px;
border-bottom-right-radius: 5px;
`
